<div class="header-container">
  <h1>Mapping</h1>
  <div class="actions">
    <button
      class="add-btn"
      nz-button
      nzType="primary"
      nzDanger
      [nzSize]="'large'"
      (click)="openMappingModal(tplContent, tplFooter)"
      >
      <span nz-icon nzType="plus"></span>
      Add a mapping
    </button>
  </div>
</div>
<div class="mapping-filter">
  <nz-select nzPlaceHolder="Attribute" [(ngModel)]="mappingFilter.attribute" name="filter_attribute" nzShowSearch required>
    <nz-option *ngFor="let a of attributes" [nzLabel]="a" [nzValue]="a"></nz-option>
  </nz-select>
  <nz-select nzPlaceHolder="Scope type" [(ngModel)]="mappingFilter.scope_type" (ngModelChange)="onFilterScopeTypeChange()" name="filter_scope_type" required>
    <nz-option *ngFor="let st of scopeTypes" [nzLabel]="st" [nzValue]="st"></nz-option>
  </nz-select>
  <nz-select
    [nzPlaceHolder]="scopeLabel(mappingFilter.scope_type)"
    [(ngModel)]="mappingFilter.scope_value"
    name="filter_scope_value"
    nzShowSearch
    required
    [nzLoading]="mappingFilter.scope_type === 'SYSTEM' && supplierSystemsLoading"
  >
    <nz-option *ngFor="let o of scopeOptions(mappingFilter.scope_type)" [nzLabel]="o.label" [nzValue]="o.value"></nz-option>
  </nz-select>
  <nz-select nzPlaceHolder="Mapping type" [(ngModel)]="mappingFilter.mapping_type" name="filter_mapping_type" nzAllowClear>
    <nz-option *ngFor="let t of mappingTypes" [nzLabel]="t" [nzValue]="t"></nz-option>
  </nz-select>
  <input nz-input placeholder="Raw value" [(ngModel)]="mappingFilter.raw_value" name="filter_raw_value" />
  <button nz-button nzType="primary" [disabled]="!(mappingFilter.attribute && mappingFilter.scope_type && mappingFilter.scope_value)" (click)="search()">
    Search
  </button>
</div>
<div class="content">
  <nz-table
    #mappingTable
    [nzData]="listOfData"
    [nzLoading]="loading"
    [nzSize]="'small'"
    [nzFrontPagination]="false"
    [nzShowPagination]="false"
    [nzFooter]="tplTableFooter"
    [nzScroll]="{ y: 'calc(100vh - 320px)' }"
    id="mapping-table"
    class="yoma-table"
  >
    <thead>
      <tr>
        <th>Attribute</th>
        <th>Scope type</th>
        <th>Brand / Supplier system</th>
        <th>Mapping type</th>
        <th>Raw value</th>
        <th class="normalized-value-column">Normalized value</th>
        <th>Exclude value</th>
        <th>Created at</th>
        <th>Updated at</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of mappingTable.data">
        <td>{{ data.attribute }}</td>
        <td>{{ data.scope_type }}</td>
        <td>{{ scopeDisplay(data) }}</td>
        <td>{{ data.mapping_type }}</td>
        <td>{{ data.raw_value }}</td>
        <td class="normalized-value-column" nz-tooltip [nzTooltipTitle]="data.normalized_value">{{ data.normalized_value }}</td>
        <td>{{ data.exclude_value }}</td>
        <td>{{ data.created_at | yomaDateFormat:'dd.MM.yyyy HH:mm' }}</td>
        <td>{{ data.updated_at | yomaDateFormat:'dd.MM.yyyy HH:mm' }}</td>
        <td>
          <button nz-button nzType="text">
            <span
              nz-icon
              nzType="edit"
              nzTheme="outline"
              (click)="openMappingModal(tplContent, tplFooter, data)"
            ></span>
          </button>
          <button nz-button nzType="text" (click)="deleteMappingModal(tplDeleteModal, tplDeleteModalFooter, data)">
            <span nz-icon nzType="delete" nzTheme="outline"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <ng-template #tplTableFooter>
    <div class="pagination-controls">
      <button nz-button [disabled]="tokenHistory.length === 0" (click)="loadPreviousPage()">Previous</button>
      <button nz-button [disabled]="!nextToken" (click)="loadNextPage()">Next</button>
    </div>
  </ng-template>

  <ng-template #tplContent let-ref="modalRef">
    <form nz-form>
      <nz-form-label nzRequired nzNoColon>Attribute</nz-form-label>
      <nz-form-item>
        <nz-form-control nzHasFeedback nzErrorTip="Attribute is required">
          <nz-select
            nzPlaceHolder="Attribute"
            [(ngModel)]="ref.getConfig().nzData.attribute"
            name="attribute"
            required="true"
            nzShowSearch
            [nzDisabled]="ref.getConfig().nzData._isEdit"
          >
            <nz-option *ngFor="let a of attributes" [nzLabel]="a" [nzValue]="a"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-label nzRequired nzNoColon>Scope type</nz-form-label>
      <nz-form-item>
        <nz-form-control nzHasFeedback nzErrorTip="Scope type is required">
          <nz-select
            nzPlaceHolder="Scope type"
            [(ngModel)]="ref.getConfig().nzData.scope_type"
            (ngModelChange)="onModalScopeTypeChange(ref.getConfig().nzData)"
            name="scope_type"
            required="true"
            [nzDisabled]="ref.getConfig().nzData._isEdit"
          >
            <nz-option *ngFor="let st of scopeTypes" [nzLabel]="st" [nzValue]="st"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-label nzRequired nzNoColon>{{ scopeLabel(ref.getConfig().nzData.scope_type) }}</nz-form-label>
      <nz-form-item>
        <nz-form-control nzHasFeedback [nzErrorTip]="scopeLabel(ref.getConfig().nzData.scope_type) + ' is required'">
          <nz-select
            [nzPlaceHolder]="scopeLabel(ref.getConfig().nzData.scope_type)"
            [(ngModel)]="ref.getConfig().nzData.scope_value"
            name="scope_value"
            required="true"
            nzShowSearch
            [nzDisabled]="ref.getConfig().nzData._isEdit || !ref.getConfig().nzData.scope_type"
            [nzLoading]="ref.getConfig().nzData.scope_type === 'SYSTEM' && supplierSystemsLoading"
          >
            <nz-option *ngFor="let o of scopeOptions(ref.getConfig().nzData.scope_type)" [nzLabel]="o.label" [nzValue]="o.value"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-label nzRequired nzNoColon>Mapping type</nz-form-label>
      <nz-form-item>
        <nz-form-control nzHasFeedback nzErrorTip="Mapping type is required">
          <nz-select
            nzPlaceHolder="Mapping type"
            [(ngModel)]="ref.getConfig().nzData.mapping_type"
            name="mapping_type"
            required="true"
            [nzDisabled]="ref.getConfig().nzData._isEdit"
          >
            <nz-option *ngFor="let t of mappingTypes" [nzLabel]="t" [nzValue]="t"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-label nzRequired>Raw value</nz-form-label>
      <nz-form-item>
        <nz-form-control nzHasFeedback nzErrorTip="Raw value is required">
          <input
            nz-input
            [(ngModel)]="ref.getConfig().nzData.raw_value"
            name="raw_value"
            required="true"
            [disabled]="ref.getConfig().nzData._isEdit"
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-label nzRequired>Normalized value</nz-form-label>
      <nz-form-item>
        <nz-form-control nzHasFeedback nzErrorTip="Normalized value is required">
          <input nz-input [(ngModel)]="ref.getConfig().nzData.normalized_value" name="normalized_value" required="true" />
        </nz-form-control>
      </nz-form-item>
      <ng-container *ngIf="ref.getConfig().nzData.mapping_type === 'REGEX_MAPPING'">
        <nz-form-label nzNoColon>Exclude value</nz-form-label>
        <nz-form-item>
          <nz-form-control>
            <input nz-input [(ngModel)]="ref.getConfig().nzData.exclude_value" name="exclude_value" />
          </nz-form-control>
        </nz-form-item>
        <!-- TODO: call BE regex validation endpoint once available -->
        <button nz-button (click)="testRegex()">Test regex</button>
        <div class="regex-test-result">{{ regexTestResult }}</div>
      </ng-container>
    </form>
  </ng-template>
  <ng-template #tplFooter let-ref="modalRef">
    <button nz-button (click)="ref.close()">Cancel</button>
    <button
      nzType="primary"
      nzDanger
      [nzLoading]="loading"
      [disabled]="
        !(
          ref.getConfig().nzData.attribute &&
          ref.getConfig().nzData.scope_type &&
          ref.getConfig().nzData.scope_value &&
          ref.getConfig().nzData.mapping_type &&
          ref.getConfig().nzData.raw_value &&
          ref.getConfig().nzData.normalized_value
        )
      "
      nz-button (click)="saveMapping(ref)"
    >
      {{ ref.getConfig().nzData._isEdit ? "Save changes" : "Add mapping" }}
    </button>
  </ng-template>
</div>

<ng-template #tplDeleteModal let-ref="modalRef">
  <p>
    This will <b>permanently remove</b> the mapping and all of its associated data  from the system. This cannot be undone.
  </p>
  <p>Enter “Delete” and the mapping's raw value into the field below to proceed:</p>
  <form nz-form>
    <nz-form-item>
      <nz-form-control nzHasFeedback nzErrorTip="Confirmation text is required">
        <input class="form-item-bordered" nz-input [(ngModel)]="deleteTextValue" name="mapping_delete_text"
               required="true" [placeholder]="'Delete ' + ref.getConfig().nzData.raw_value"/>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-template>
<ng-template #tplDeleteModalFooter let-ref="modalRef">
  <button nz-button (click)="ref.close()">Cancel</button>
  <button nz-button (click)="deleteMapping(ref)" [nzLoading]="loading" nzDanger nzType="primary"
    [disabled]="deleteTextValue != ('Delete ' + ref.getConfig().nzData.raw_value)"
    >Delete</button>
</ng-template>
